import { ArmourType, WeaponType } from "../../models/enums";

export const minimalCharms = ["Thawing Charm", "Golden Charm"];
export const minimalJewels = ["None"];

export const rareOnlySpecialJewellery = [
  // Amulets
  "Corona Amulet",
  "Tenebrous Amulet", "Penumbra Amulet", "Dusk Amulet", "Gloam Amulet",
  // Rings
  "Breach Ring", "Refined Breach Ring",
  "Tenebrous Ring", "Penumbra Ring", "Dusk Ring", "Gloam Ring",
  "Biostatic Ring", "Vitalic Ring", "Mnemonic Ring", "Kinetic Ring", "Oneiric Ring", "Grasping Ring",
  // Belts
  "Stalking Belt", "Invoking Belt", "Sinew Belt", "Forking Belt",
];

export const currencyTypesToHide = ["Regular Runes", "Legacy Runes", "Essences", "Uncut Gems", "Lineage Gems"];

export const currencyTypesNotDroppable: string[] = ["Omens", "Legacy Runes", "Perfect Runes"];

export const ruthlessDisabledCurrencyItems: string[] = [];

export const ruthlessDisabledCurrencyTypes: string[] = [];

export const ruthlessOnlyCurrencyItems: string[] = [];

export const alwaysUseFixedValueCurrency = ["Scroll of Wisdom"];

export const defaultFavouriteBasicCurrencyTypes: string[] = [
  "Vaal Orb", "Orb of Alchemy", "Chaos Orb", "Exalted Orb", "Divine Orb",
  "Greater Regal Orb", "Perfect Regal Orb",
  "Greater Exalted Orb", "Perfect Exalted Orb",
  "Greater Chaos Orb", "Perfect Chaos Orb",
  "Perfect Orb of Augmentation", "Perfect Orb of Transmutation"];

export const cheapCurrency = [
  "Transmutation Shard",
  "Artificer's Shard",
  "Regal Shard",
  "Chance Shard",
  "Orb of Augmentation",
  "Orb of Transmutation",
  "Armourer's Scrap",
  "Blacksmith's Whetstone",
  "Arcanist's Etcher",
  "Artificer's Orb",
  "Glassblower's Bauble",
  "Gemcutter's Prism",
  "Vaal Orb",
  "Regal Orb",
  "Orb of Alchemy",
  "Chaos Orb",
  "Lesser Jeweller's Orb",
  "Greater Jeweller's Orb",
  "Greater Orb of Augmentation",
  "Greater Orb of Transmutation",
  "Greater Regal Orb",
  "Perfect Orb of Augmentation",
  "Perfect Orb of Transmutation",
  "Perfect Regal Orb",
  "Exalted Orb",
];

export const stackableCurrency = [
  // All currency that can drop in stacks
  "Scroll of Wisdom",
  "Orb of Augmentation", "Greater Orb of Augmentation", "Perfect Orb of Augmentation",
  "Orb of Transmutation", "Greater Orb of Transmutation", "Perfect Orb of Transmutation",
  "Orb of Chance",
  "Orb of Alchemy",
  "Regal Orb", "Greater Regal Orb", "Perfect Regal Orb",
  "Chaos Orb", "Greater Chaos Orb", "Perfect Chaos Orb",
  "Exalted Orb", "Greater Exalted Orb", "Perfect Exalted Orb",
  "Vaal Orb",
  "Divine Orb",
  "Orb of Annulment",
  "Lesser Jeweller's Orb", "Greater Jeweller's Orb", "Perfect Jeweller's Orb",
  "Armourer's Scrap", "Blacksmith's Whetstone", "Arcanist's Etcher",
  "Glassblower's Bauble", "Gemcutter's Prism",
  "Artificer's Orb",

  // Splinters
  "Breach Splinter", "Simulacrum Splinter",

  // Liquid Emotions (low- & mid-tier; drop in stacks from Delirium)
  "Diluted Liquid Ire", "Diluted Liquid Guilt", "Diluted Liquid Greed",
  "Liquid Paranoia", "Liquid Envy", "Liquid Disgust", "Liquid Despair",

  // Runeforging (Remnant Runecrafting; common orbs & quality currency are listed above)
  "Exceptional Verisium",
];

export const itemColors = {
  normal: 'rgb(200,200,220)',
  magic: 'rgb(122,151,254)',
  rare: 'rgb(254,224,85)',
  unique: 'rgb(240,105,22)',
  currency: 'rgb(170,158,130)',
  gold: 'rgb(170,158,130)',
  divinationCard: 'rgb(27,162,155)',
};

export const restrictedDropTypesToTreatAsRegular = [
  "Corrupted Nexus",
  "Possessed Monsters",
  "Random Monsters",
  "Delirium",
  "Expedition",
  "Breach",
  "Recipe",
];

export const nonDroppableUniqueBossTypes = [
  "Recipe",
];

export const cantHaveQualityItemClasses: string[] = [
  'Belts', 'Stackable Currency', 'Essences', 'Ancient Bones', 'Abyssal Eyes', 'Expedition Logbooks',
  'Jewels', 'Omen', 'Relics', 'Socketable', 'Augment', 'Runes', 'Soul Cores', 'Idols', 'Vault Keys',
  'Tablet', 'Trial Coins', 'Ultimatums', 'Incubators',
];

export const cantHaveSocketsItemClasses: string[] = [
  ...cantHaveQualityItemClasses,
  'Amulets', 'Rings', 'Belts', 'Life Flasks', 'Mana Flasks', 'Charms', 'Skill Gems', 'Support Gems', 'Maps',
  'Waystones',
];

export const itemTypesWithTwoSockets: string[] = [
  WeaponType.Bows,
  WeaponType.Crossbows,
  WeaponType.Quarterstaves,
  WeaponType.Staves,
  WeaponType.Talismans,
  WeaponType.TwoHandMaces,
  ArmourType.BodyArmours,
];

export const excludedChanceBaseItemClasses: string[] = [
  'Jewels',
];

export const hardCodedChanceBases: string[] = [
  "Heavy Belt",
  "Utility Belt",
  "Irradiated Tablet"
]
